import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import React, { useMemo } from "react";
import { FluidMetricsResponse } from "sharedTypes";

export const FluidMetricsTable: React.FC<FluidMetricsTableInterface> = ({
  data,
  loading,
  error,
  pagination
}) => {
  console.log("data", data);
  const columns: ColumnsType<FluidMetricsResponse> = useMemo(
    () => [
      {
        title: "Date",
        dataIndex: "date",
        key: "date"
      },
      {
        title: "Pre-Wt (kg)",
        dataIndex: "pre_wt",
        key: "pre_wt"
      },
      {
        title: "Post-Wt (kg)",
        dataIndex: "post_wt",
        key: "post_wt"
      },
      {
        title: "TW (kg)",
        dataIndex: "tw",
        key: "tw"
      },
      {
        title: "Pre-BP",
        dataIndex: "pre_bp",
        key: "pre_bp"
      },
      {
        title: "Post-BP",
        dataIndex: "post_bp",
        key: "post_bp"
      },
      {
        title: "Lowest BP",
        dataIndex: "lowest_bp",
        key: "lowest_bp"
      },
      {
        title: "Duration (min)",
        dataIndex: "duration",
        key: "duration"
      },
      {
        title: "Recommendation",
        dataIndex: "recommmedation",
        key: "recommmedation"
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status: string) => {
          const isAccepted = status?.toLowerCase() === "accepted";
          const isDenied = status?.toLowerCase() === "denied";
          return (
            <span
              style={{
                color: isAccepted ? "#28a745" : isDenied ? "#dc3545" : "#000",
                backgroundColor: isAccepted
                  ? "#d4edda"
                  : isDenied
                  ? "#f8d7da"
                  : "#f1f1f1",
                padding: "2px 10px",
                borderRadius: "12px",
                fontWeight: 500
              }}
            >
              {status}
            </span>
          );
        }
      }
    ],
    []
  );

  return useMemo(
    () => (
      <Table
        columns={columns}
        dataSource={data ?? []}
        loading={loading}
        pagination={pagination}
        data-testid="fluid-metrics-table"
      />
    ),
    [columns, data, loading, pagination]
  );
};

export interface FluidMetricsTableInterface {
  readonly data?: FluidMetricsResponse[];
  readonly loading?: boolean;
  readonly error?: unknown;
  readonly pagination?: TablePaginationConfig;
}
